
export const  LAUNCH_CONTAINER_OPTIONS: string[] = [
  //"EMBED",
  //'IFRAME',
  //'SAME_WINDOW',
  'NEW_WINDOW',
  //TODO: this option is getting chopped in the UI coz of z-index
];

export const  TARGET_LINK_URI_CUSTOMIZATION_VALUES: string[] = [
  'REDIRECT_URI', 'AS_PER_SPEC'
];